









import { Component, Vue, Prop, Emit } from "vue-property-decorator";

export interface GameSubject {
  id?: number;
  title?: string;
  details?: string;
  url?: string;
}

@Component
export default class Games extends Vue {
  @Prop() public games?: GameSubject[];
}
